<template>
  <div class="w-full">
    <AppLabel :mode="mode" :htmlFor="id" :title="title" />
    <div class="flex">
      <textarea
        :id="id"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        class="form-control !h-[100px] !resize-none py-3"
        :class="[mode === 'dark' ? 'dark-form-control' : '', classes]"
        :placeholder="placeholder"
      />
    </div>
  </div>
</template>

<script>
import AppLabel from "@C/Form/AppLabel.vue";

export default {
  name: "Textarea",
  props: {
    mode: String,
    id: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    modelValue: [String, Number],
    placeholder: {
      type: String,
      default: "",
    },
    classes: {
      type: String,
      default: "",
    },
  },
  components: {
    AppLabel,
  },
};
</script>
